import { ACH_RELATIONSHIP_STATUSES } from "@tastyworks/tastyworks-api"
import { boolean, number, object, string } from "yup"

export const linkBankSchema = object({
  hasSkipped: boolean().required().default(false),
  // The Plaid flow is launched after form submission, therefore achStatus is optional
  // so it does not block submission. It will be set programmatically after
  // the Plaid flow resolves.
  achStatus: string()
    .oneOf(Object.values(ACH_RELATIONSHIP_STATUSES))
    .optional(),
})

export const depositSchema = object({
  hasSkipped: boolean().required().default(false),
  amount: number()
    .positive()
    .typeError("Must be a number")
    .when("hasSkipped", {
      is: false,
      then: (schema) => schema.required(),
    }),
})

export const confirmDepositSchema = object({
  hasSkipped: boolean().required().default(false),
  hasConfirmed: boolean().required().default(false),
})

export const fundingSchema = object({
  linkBank: linkBankSchema,
  deposit: depositSchema,
  confirmDeposit: confirmDepositSchema,
})
